import { apiUrl } from '../../../../../constants/global';
import axios from 'axios';
import { getLoggedUser } from '../../../../../state/user';
import { saveAs } from 'file-saver';

const user = getLoggedUser();
const endpoint = apiUrl + 'v2';

async function getAuctions(filters) {
  const query = new URLSearchParams(filters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}/auctions?${query}`, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getAuctionCategories(filters) {
  const query = new URLSearchParams(filters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}/categories/list?${query}`, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

// services/auctionService.js

async function bulkApproveAuctions(data) {
  try {
    const response = await fetch(`${endpoint}/auctions/bulk-action`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`,
      },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.error('Bulk approve error:', error);
    throw error;
  }
}

async function bulkInvoiceAuctions(data) {
  try {
    const response = await fetch(`${endpoint}/auctions/download/bulk-invoice`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Download failed');
    }

    // ✅ Handle as BLOB for file download
    const blob = await response.blob();

    // Get filename from Content-Disposition header
    const contentDisposition = response.headers.get('Content-Disposition');
    const filename = contentDisposition
      ? contentDisposition.split('filename=')[1].replace(/"/g, '')
      : `auction_invoices_${data.lang}_${Date.now()}.zip`;

    // Trigger download
    saveAs(blob, filename);

    return { success: true, filename };
  } catch (error) {
    console.error('Bulk invoice download error:', error);
    throw error;
  }
}

export { getAuctions, getAuctionCategories, bulkApproveAuctions, bulkInvoiceAuctions };
